module.exports = __webpack_public_path__ + "img/153.bfebc673.jpg";